// extracted by mini-css-extract-plugin
export var fontNunitoSans = "'Nunito Sans'";
export var iconContainer = "PerkList_iconContainer__jIeFW";
export var md = "768px";
export var perkDescription = "PerkList_perkDescription__Dz9aC";
export var perkList = "PerkList_perkList__-zTRD";
export var perkListContainer = "PerkList_perkListContainer__zmoy8";
export var perkTitle = "PerkList_perkTitle__Xhovg";
export var shared = "'../shared.module.css'";
export var termsLink = "PerkList_termsLink__1P+b+";
export var wrapper = "PerkList_wrapper__hCwZV";